// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../resources/images/general/main_background.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../resources/images/icons/header/down_arrow.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#app,
#app {
  height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.bgu {
  /* The image used */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});

  /* Full height */
  height: 100%;

  /* Center and scale the image nicely */
  /* background-position: left; */

  background-size: cover;
  background-repeat: no-repeat;
}

.list-group-scroll {
  max-height: 400px;
  margin-bottom: 10px;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
}

.scrollable-menu {
  height: auto;
  max-height: 70vh;
  overflow-x: hidden;
}

.modal.fade {
  z-index: 10000000 !important;
}

body {
  font-family: 'Source Sans Pro', sans-serif;
  background-color: var(--grey96);
  background-color: var(--grey96);
}

.dropdown-item:active {
  background: var(--grey91) !important;
  background: var(--grey91) !important;
}

.text-underline:hover {
  text-decoration: underline;
}

.dashboard-button:hover {
  color: #dfe7f0;
}
.placeholder::-moz-placeholder {
  color: #919db4;
}
.placeholder::placeholder {
  color: #919db4;
}

@media (max-width: 768px) {
  .dashboard-button {
    font-size: 13px;
    font-weight: 400;

    color: #ffffff;
    background-color: #4d5674;
    width: 120px;
    height: 34px;
    border-radius: 26px;
    padding: 0;
  }
}

@media (min-width: 768px) {
  .dashboard-button {
    font-size: 16px;
    font-weight: 400;

    color: #ffffff;
    background-color: #4d5674;
    width: 160px;
    height: 34px;
    border-radius: 26px;
    padding: 0;
  }
}

.dashboard-button.dashboard-button-selected {
  background-color: #4563c7;
}

.general-button {
  width: 143px;
  height: 44px;
  border-radius: 26px;
  color: #ffffff;
  padding: 0;
  margin: 0;
}

.footer-button-cancel {
  width: 120px;
  height: 40px;
  border-radius: 3px;
  padding: 8px 16px;
  margin: 0px 8px;
  font-size: 16px;
  color: #4d5674;
  border: 1px solid #919db4;
}

.footer-button-cancel:hover {
  background-color: #f6f8fa;
  color: #4d5674;
  border: 1px solid #919db4;
}

.footer-button-cancel:active {
  background-color: #dce0e8;
  color: #4d5674;
  border: 1px solid #919db4;
}
.footer-button-cancel:disabled {
  background-color: transparent;
  color: #999ca3;
  border: 1px solid #d0d3d9;
}

.footer-button-save {
  width: 120px;
  height: 40px;
  border-radius: 3px;
  padding: 8px 16px;
  margin: 0px 8px;
  font-size: 16px;
  color: #ffffff;
  background: #4563c7;
}
.footer-button-save:hover {
  background-color: #2545b0;
  color: #ffffff;
}

.footer-button-save:active {
  background-color: #1b3280;
  color: #ffffff;
}

.footer-button-save:disabled {
  background-color: #d0d3d9;
  color: #ffffff;
}

.underline {
  -webkit-text-decoration-line: underline !important;
          text-decoration-line: underline !important;
  -webkit-text-decoration-style: solid !important;
          text-decoration-style: solid !important;
  -webkit-text-decoration-color: #4563c7 !important ;
          text-decoration-color: #4563c7 !important ;
  text-decoration-thickness: 3px !important ;
  text-underline-offset: 11px !important;
}

@media (max-width: 768px) {
  .supporting_data {
    width: 100%;
  }
}

@media (min-width: 992px) {
  .side-bar {
    position: fixed;
  }
}

@media (min-width: 768px) {
  .main-screen {
    margin-left: 0px;
  }
}

@media (max-width: 768px) {
  .image-buttons {
    height: 30px;
    width: 30px;
  }
}

.logo-image-height {
  height: 58px;
  height: 53px;
}

.font-weight-semi-bold {
  font-weight: 600;
}

.line-height-1 {
  line-height: 1;
}

.text-size-10 {
  font-size: 10px;
}

.text-size-12 {
  font-size: 12px;
}

.text-size-13 {
  font-size: 13px;
}

.text-size-14 {
  font-size: 14px;
}

.text-size-16 {
  font-size: 16px;
}

.text-size-18 {
  font-size: 18px;
}

.text-size-22 {
  font-size: 22px;
}

.text-size-20 {
  font-size: 20px;
}

.text-size-24 {
  font-size: 24px;
}

.text-size-26 {
  font-size: 26px;
}

.text-size-28 {
  font-size: 28px;
}

.text-size-32 {
  font-size: 32px;
}
.text-size-36 {
  font-size: 36px;
}

.text-size-42 {
  font-size: 42px;
}

.text-size-48 {
  font-size: 48px;
}

.text-size-52 {
  font-size: 52px;
}

.card-shadow {
  box-shadow: 0 0px 20px 0 rgba(0, 0, 0, 0.05);
}

@media (min-width: 768px) {
  .text-size-nitrogen {
    font-size: 24px;
  }
}

@media (max-width: 1480px) {
  .fieldDetails {
    flex-wrap: wrap;
  }
}
@media (max-width: 1480px) {
  .IrrigationMeterDetailsContainer {
    width: 100% !important;
    justify-content: center;
    border-top-right-radius: 14px;
    border-right: 1px solid #dce0e8 !important;
    border-bottom: none !important;
  }
}

@media (min-width: 1480px) {
  .FieldDetailsContainer {
    border-top-right-radius: 14px;
  }
}

@media (max-width: 1480px) {
  .FieldDetailsContainer {
    border-left: 0.5px solid #dce0e8;
  }
}

@media (max-width: 1480px) {
  .lastUpdatedGaugeText {
    font-size: 14px !important;
  }
}

@media (min-width: 2160px) {
  .fieldDetailsLargeScreens {
    line-height: 55px !important;
  }
}

/*4 lines height*/
@media (max-width: 1560px) {
  .nextActionsContainer {
    max-height: 256px !important;
  }
}
@media (max-width: 1480px) {
  .gaugeTitlesContainer {
    flex-direction: row !important;
    align-items: center !important;
  }
}
@media (max-width: 768px) {
  .accumulatedAbsoluteMenu {
    margin-top: 70px !important;
  }
}

@media (min-width: 2660px) {
  .accumulatedAbsoluteMenu {
    margin-left: 88px !important;
    margin-top: 55px !important;
  }
}

@media (min-width: 3060px) {
  .accumulatedAbsoluteMenu {
    margin-left: 92px !important;
  }
}

@media (min-width: 3400px) {
  .accumulatedAbsoluteMenu {
    margin-left: 93px !important;
  }
}

@media (min-width: 4000px) {
  .accumulatedAbsoluteMenu {
    margin-left: 95px !important;
  }
}

@media (min-width: 4700px) {
  .accumulatedAbsoluteMenu {
    margin-left: 97px !important;
  }
}

@media (min-width: 5000px) {
  .accumulatedAbsoluteMenu {
    margin-left: 102px !important;
  }
}
@media (min-width: 5500px) {
  .accumulatedAbsoluteMenu {
    margin-left: 108px !important;
  }
}
@media (max-width: 1560px) {
  .nextActionsContainerGraphOnly {
    max-width: none !important;
  }
}

@media (max-width: 1560px) {
  .dashboardNextActionsContainerGraphOnly {
    flex-wrap: wrap !important;
  }
}
@media (max-width: 1200px) {
  .dashboardNextActionsContainer {
    max-width: none !important;
  }
}

@media (max-width: 768px) {
  .text-size-nitrogen {
    font-size: 18px;
  }
}

@media (min-width: 768px) {
  .text-size-fertilizer-title {
    font-size: 18px;
  }
}
@media (max-width: 768px) {
  .text-size-fertilizer-title {
    font-size: 14px;
  }
}

canvas#da-gauge {
  width: 100% !important;
  height: auto !important;
}

.dropdown-hover > .dropdown-menu {
  top: 200%;
  transition: 0.3s all ease-in-out;
}
.dropdown-hover:hover > .dropdown-menu {
  display: block;
  top: 100%;
}

.dropdown-hover > .dropdown-toggle:active {
  /*Without this, clicking will make it sticky*/
  pointer-events: none;
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeout {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@keyframes slide_irrigation {
  from {
    width: 0;
  }
  to {
    width: 255px;
  }
}
@keyframes slide_nitrogen {
  from {
    width: 0;
  }
  to {
    width: 255px;
  }
}

@keyframes slide_close {
  from {
    width: 255px;
  }
  to {
    width: 0;
  }
}

.custom-checkbox input {
  height: 16px;
  width: 16px;
  position: absolute;
  top: 2px;
  left: 1px;
  opacity: 0;
}
.custom-checkbox span {
  /* <-- Style the artificial checkbox */
  height: 14px;
  width: 14px;
  border: 1px solid #dfe7f0;
  display: inline-block;

  border-radius: 4px;

  box-shadow:
    inset 0px 1px 1px white,
    0px 1px 1px rgba(0, 0, 0, 0.5);
}

[type='checkbox']:checked + span.check-blue {
  /* <-- Style its checked state */
  background: #3f83f7 0% 0% no-repeat padding-box;
}
[type='checkbox']:checked + span.check-green {
  /* <-- Style its checked state */
  background: #00c1a7 0% 0% no-repeat padding-box;
}

[type='checkbox']:checked + span.check-orange {
  /* <-- Style its checked state */
  background: #ef9331 0% 0% no-repeat padding-box;
}

[type='checkbox']:checked + span.check-pink {
  /* <-- Style its checked state */
  background: #cd91cd 0% 0% no-repeat padding-box;
}

[type='checkbox']:checked + span.check-blue-third {
  /* <-- Style its checked state */
  background: #94c7f6 0% 0% no-repeat padding-box;
}

[type='checkbox']:checked + span.check-indigo-light {
  /* <-- Style its checked state */
  background: #5e70d1 0% 0% no-repeat padding-box;
}

::-moz-placeholder {
  color: #a8abb7;
  font-weight: normal;
}

::placeholder {
  color: #a8abb7;
  font-weight: normal;
}

.modal-dialog {
  max-width: 860px;
}

.line-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.tooltip-inner {
  background-color: rgba(77, 86, 116, 1);
  color: rgba(255, 255, 255, 1);
  padding: 4px 0px;
  font-family: Source Sans Pro;
  line-height: 150%;
  max-width: 280px;
  padding: 8px 10px;
  box-shadow: 0px 3px 6px 0px rgba(28, 29, 32, 0.3);
  text-align: left;
}

.disable-selector {
  background: #edeff2 url(${___CSS_LOADER_URL_REPLACEMENT_1___})
    right 0.75rem center/8px 10px no-repeat !important;
}

.tooltip.show {
  opacity: 1 !important;
}

.tooltip.bs-tooltip-top .arrow:before {
  border-top-color: rgba(77, 86, 116, 1) !important;
}
.tooltip.bs-tooltip-bottom .arrow:before {
  border-bottom-color: rgba(77, 86, 116, 1) !important;
}
.tooltip.bs-tooltip-right .arrow:before {
  border-right-color: rgba(77, 86, 116, 1) !important;
}
.tooltip.bs-tooltip-bottom .tooltip-inner {
  max-width: 180px;
}

.color-transition {
  background-color: #e1e4eb; /* Initial color */
  transition: background-color 600ms ease-in-out; /* Transition property and duration */
  animation: colorTransition 600ms infinite alternate;
}

.white-selector {
  background: white url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right
    0.75rem center/8px 10px no-repeat !important;
}
.disable-selector {
  background: #edeff2 url(${___CSS_LOADER_URL_REPLACEMENT_1___})
    right 0.75rem center/8px 10px no-repeat !important;
}

@keyframes colorTransition {
  to {
    background-color: #d0d4db; /* Final color */
  }
}

.form-control:focus {
  border-color: rgba(69, 99, 199, 1);
  box-shadow: 0 0 0 0;
}

.form-control:not(:disabled):hover {
  background-color: rgba(250, 251, 252, 1);
}

.btn-link:focus {
  text-decoration: none;
}
.btn:focus {
  outline: 0;
  box-shadow: 0 0 0 0;
}

.dropdown-item:hover {
  background: #eef1f6;
}

.delete-dropdown-item:hover {
  background: #fff5f6;
}

.button-big {
  background-color: rgba(238, 241, 246, 1) !important;
}

.button-big:hover {
  background-color: rgba(220, 224, 232, 1) !important;
  border: 1px solid rgba(145, 157, 180, 1) !important;
}

.button-big:active {
  background-color: rgba(246, 248, 250, 1) !important;
  border: 1px solid rgba(220, 224, 232, 1) !important;
}

.button-primary {
  background-color: rgba(69, 99, 199, 1) !important;
}

.button-primary:hover {
  background-color: rgba(37, 69, 176, 1) !important;
}

.button-primary:active {
  background-color: rgba(27, 50, 128, 1) !important;
}

.modal-backdrop {
  z-index: 999;
  background: rgba(27, 31, 46, 0.3);
}
.modal-tall .modal-content {
  height: 100%;
}
.alert_div:hover {
  background-color: #f6f8fa;
}
.tooltip {
  z-index: 99999999999999 !important;
}

.modal-slide .modal-dialog {
  transform: translate(100%, 0);
  transition: transform 0.5s ease-out;
}

.modal-slide.show .modal-dialog {
  transform: translate(0, 0);
}

.modal-slide.hide .modal-dialog {
  transform: translate(100%, 0);
  transition: transform 0.5s ease-in-out;
}

input[type='radio'] {
  accent-color: #4563c7;
}

input[type='checkbox'] {
  accent-color: #4563c7;
}

.addBtn {
  background: white;
}

.addBtn:hover {
  background: rgba(238, 241, 246, 0.6);
}

.addBtn:focus {
  background: rgba(220, 224, 232, 0.5);
}

.title {
  color: #d0d3d9;
}

.title_active {
  color: #4d5674;
}

.title:hover {
  color: #4563c7;
}

.danger-button {
  background-color: var(--color-danger-idel);
  background-color: var(--color-danger-idel);
  color: white;
  border: none;
}

.danger-button:hover {
  background-color: var(--color-danger-hover);
  background-color: var(--color-danger-hover);
}

.danger-button:focus {
  background-color: var(--color-danger-idel);
  background-color: var(--color-danger-idel);
}

#link_div:hover ~ .underline_div {
  background-color: #4563c7;
}
.underline_div {
  background-color: #4d5674;
}

.custom-select {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right
    0.75rem center/8px 10px no-repeat !important;
}

.DayPickerInput-OverlayWrapperRight {
  right: 12px;
  position: absolute;
  background-color: white;
  margin-top: 2px;
  z-index: 1;
}
.archive-color {
  color: #919db4 !important;
}

.chip {
  height: 32px;
  border-radius: 30px;
  padding: 8px 16px 8px 16px;
  line-height: 16px;
  color: var(--color-grey-45);
  color: var(--color-grey-45);
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  margin-right: 8px;
  cursor: pointer;
  margin-bottom: 8px;
}

.chip--selected {
  background-color: var(--color-grey-45);
  background-color: var(--color-grey-45);
  color: white;
}

.chip--selected:hover {
  background-color: var(--color-grey-34);
  background-color: var(--color-grey-34);
  color: var(--color-grey-100);
  color: var(--color-grey-100);
}

.chip--selected:active {
  background-color: var(--color-grey-25);
  background-color: var(--color-grey-25);
  color: var(--color-grey-100);
  color: var(--color-grey-100);
}

.chip--notselected {
  background-color: var(--color-grey-96);
  background-color: var(--color-grey-96);
  color: var(--color-grey-45);
  color: var(--color-grey-45);
}

.chip--notselected:hover {
  background-color: var(--color-grey-91);
  background-color: var(--color-grey-91);
  color: var(--color-grey-45);
  color: var(--color-grey-45);
}

.chip--notselected:active {
  background-color: var(--color-grey-96);
  background-color: var(--color-grey-96);
  color: var(--color-grey-25);
  color: var(--color-grey-25);
}

.chip--disabled {
  background-color: var(--color-disabled-95);
  background-color: var(--color-disabled-95);
  color: var(--color-disabled-64);
  color: var(--color-disabled-64);
  cursor: auto;
}

.modal-input-container {
  width: 142px;
}

.deleteItem:hover {
  background: #fff5f6 !important;
}

.disabled-button {
  background-color: var(--color-disabled-85);
  background-color: var(--color-disabled-85);
  align-items: center;
  display: flex;
}

.primary-button {
  background-color: var(--color-primary-idel);
  background-color: var(--color-primary-idel);
  align-items: center;
  display: flex;
  border: transparent;
}

.primary-button:hover {
  background-color: var(--color-primary-hover);
  background-color: var(--color-primary-hover);
}

.primary-button:active {
  background-color: var(--color-primary-on-press);
  background-color: var(--color-primary-on-press);
}
.primary-button:disabled {
  background-color: var(--color-disabled-85);
  background-color: var(--color-disabled-85);
  pointer-events: none;
}
.secondary-button {
  background-color: var(--color-grey-96);
  background-color: var(--color-grey-96);
  border: 1px solid var(--color-grey-91);
  border: 1px solid var(--color-grey-91);
  align-items: center;
  display: flex;
}

.secondary-button:hover {
  background-color: var(--color-grey-91);
  background-color: var(--color-grey-91);
  border: 1px solid var(--color-grey-98);
  border: 1px solid var(--color-grey-98);
}

.secondary-button:active {
  background-color: var(--color-grey-98);
  background-color: var(--color-grey-98);
  border: 1px solid var(--color-grey-91);
  border: 1px solid var(--color-grey-91);
}

.ghost-button {
  background-color: white;
  border: 1px solid var(--color-grey-71);
  border: 1px solid var(--color-grey-71);
  color: var(--color-grey-45);
  color: var(--color-grey-45);
}

.ghost-button:hover {
  background-color: var(--color-grey-98);
  background-color: var(--color-grey-98);
  border: 1px solid var(--color-grey-71);
  border: 1px solid var(--color-grey-71);
}

.ghost-button:active {
  background-color: var(--color-grey-91);
  background-color: var(--color-grey-91);
  border: 1px solid var(--color-grey-71);
  border: 1px solid var(--color-grey-71);
}

.css-6hp17o-MuiList-root-MuiMenu-list {
  list-style: none;
  margin: 0;
  padding: 0;
  position: relative;
  outline: 0;
}
`, "",{"version":3,"sources":["webpack://./app/styles/main.css"],"names":[],"mappings":"AAAA;;;;EAIE,YAAY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,yDAAwE;;EAExE,gBAAgB;EAChB,YAAY;;EAEZ,sCAAsC;EACtC,+BAA+B;;EAE/B,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0CAA0C;EAC1C,+BAA+B;EAA/B,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EAApC,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AAFA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;;IAEhB,cAAc;IACd,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;;IAEhB,cAAc;IACd,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kDAA0C;UAA1C,0CAA0C;EAC1C,+CAAuC;UAAvC,uCAAuC;EACvC,kDAA0C;UAA1C,0CAA0C;EAC1C,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;IAC7B,0CAA0C;IAC1C,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,8BAA8B;IAC9B,8BAA8B;EAChC;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;AACA;EACE;IACE,6BAA6B;EAC/B;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,6CAA6C;EAC7C,oBAAoB;AACtB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,QAAQ;EACV;EACA;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,QAAQ;EACV;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,QAAQ;EACV;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;AACZ;AACA;EACE,sCAAsC;EACtC,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,qBAAqB;;EAErB,kBAAkB;;EAElB;;kCAEgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,+CAA+C;AACjD;AACA;EACE,gCAAgC;EAChC,+CAA+C;AACjD;;AAEA;EACE,gCAAgC;EAChC,+CAA+C;AACjD;;AAEA;EACE,gCAAgC;EAChC,+CAA+C;AACjD;;AAEA;EACE,gCAAgC;EAChC,+CAA+C;AACjD;;AAEA;EACE,gCAAgC;EAChC,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAHA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,6BAA6B;EAC7B,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE;sDACoD;AACtD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iDAAiD;AACnD;AACA;EACE,oDAAoD;AACtD;AACA;EACE,mDAAmD;AACrD;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB,EAAE,kBAAkB;EAC7C,8CAA8C,EAAE,qCAAqC;EACrF,mDAAmD;AACrD;;AAEA;EACE;gDAC8C;AAChD;AACA;EACE;sDACoD;AACtD;;AAEA;EACE;IACE,yBAAyB,EAAE,gBAAgB;EAC7C;AACF;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,mDAAmD;EACnD,mDAAmD;AACrD;;AAEA;EACE,mDAAmD;EACnD,mDAAmD;AACrD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kCAAkC;AACpC;;AAEA;EAGE,6BAA6B;EAE7B,mCAAmC;AAIrC;;AAEA;EAGE,0BAA0B;AAC5B;;AAEA;EAGE,6BAA6B;EAE7B,sCAAsC;AAIxC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAA1C,0CAA0C;EAC1C,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,2CAA2C;EAA3C,2CAA2C;AAC7C;;AAEA;EACE,0CAA0C;EAA1C,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE;gDAC8C;AAChD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,UAAU;AACZ;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,2BAA2B;EAA3B,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EAAtC,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,sCAAsC;EAAtC,sCAAsC;EACtC,4BAA4B;EAA5B,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;EAAtC,sCAAsC;EACtC,4BAA4B;EAA5B,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;EAAtC,sCAAsC;EACtC,2BAA2B;EAA3B,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EAAtC,sCAAsC;EACtC,2BAA2B;EAA3B,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EAAtC,sCAAsC;EACtC,2BAA2B;EAA3B,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;EAA1C,0CAA0C;EAC1C,+BAA+B;EAA/B,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0CAA0C;EAA1C,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,2CAA2C;EAA3C,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;EAA5C,4CAA4C;AAC9C;;AAEA;EACE,+CAA+C;EAA/C,+CAA+C;AACjD;AACA;EACE,0CAA0C;EAA1C,0CAA0C;EAC1C,oBAAoB;AACtB;AACA;EACE,sCAAsC;EAAtC,sCAAsC;EACtC,sCAAsC;EAAtC,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,sCAAsC;EAAtC,sCAAsC;EACtC,sCAAsC;EAAtC,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EAAtC,sCAAsC;EACtC,sCAAsC;EAAtC,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;EACvB,sCAAsC;EAAtC,sCAAsC;EACtC,2BAA2B;EAA3B,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EAAtC,sCAAsC;EACtC,sCAAsC;EAAtC,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EAAtC,sCAAsC;EACtC,sCAAsC;EAAtC,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,UAAU;AACZ","sourcesContent":["html,\nbody,\n#app,\n#app {\n  height: 100%;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.bgu {\n  /* The image used */\n  background-image: url('../resources/images/general/main_background.jpg');\n\n  /* Full height */\n  height: 100%;\n\n  /* Center and scale the image nicely */\n  /* background-position: left; */\n\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n\n.list-group-scroll {\n  max-height: 400px;\n  margin-bottom: 10px;\n  overflow: scroll;\n  -webkit-overflow-scrolling: touch;\n}\n\n.scrollable-menu {\n  height: auto;\n  max-height: 70vh;\n  overflow-x: hidden;\n}\n\n.modal.fade {\n  z-index: 10000000 !important;\n}\n\nbody {\n  font-family: 'Source Sans Pro', sans-serif;\n  background-color: var(--grey96);\n}\n\n.dropdown-item:active {\n  background: var(--grey91) !important;\n}\n\n.text-underline:hover {\n  text-decoration: underline;\n}\n\n.dashboard-button:hover {\n  color: #dfe7f0;\n}\n.placeholder::placeholder {\n  color: #919db4;\n}\n\n@media (max-width: 768px) {\n  .dashboard-button {\n    font-size: 13px;\n    font-weight: 400;\n\n    color: #ffffff;\n    background-color: #4d5674;\n    width: 120px;\n    height: 34px;\n    border-radius: 26px;\n    padding: 0;\n  }\n}\n\n@media (min-width: 768px) {\n  .dashboard-button {\n    font-size: 16px;\n    font-weight: 400;\n\n    color: #ffffff;\n    background-color: #4d5674;\n    width: 160px;\n    height: 34px;\n    border-radius: 26px;\n    padding: 0;\n  }\n}\n\n.dashboard-button.dashboard-button-selected {\n  background-color: #4563c7;\n}\n\n.general-button {\n  width: 143px;\n  height: 44px;\n  border-radius: 26px;\n  color: #ffffff;\n  padding: 0;\n  margin: 0;\n}\n\n.footer-button-cancel {\n  width: 120px;\n  height: 40px;\n  border-radius: 3px;\n  padding: 8px 16px;\n  margin: 0px 8px;\n  font-size: 16px;\n  color: #4d5674;\n  border: 1px solid #919db4;\n}\n\n.footer-button-cancel:hover {\n  background-color: #f6f8fa;\n  color: #4d5674;\n  border: 1px solid #919db4;\n}\n\n.footer-button-cancel:active {\n  background-color: #dce0e8;\n  color: #4d5674;\n  border: 1px solid #919db4;\n}\n.footer-button-cancel:disabled {\n  background-color: transparent;\n  color: #999ca3;\n  border: 1px solid #d0d3d9;\n}\n\n.footer-button-save {\n  width: 120px;\n  height: 40px;\n  border-radius: 3px;\n  padding: 8px 16px;\n  margin: 0px 8px;\n  font-size: 16px;\n  color: #ffffff;\n  background: #4563c7;\n}\n.footer-button-save:hover {\n  background-color: #2545b0;\n  color: #ffffff;\n}\n\n.footer-button-save:active {\n  background-color: #1b3280;\n  color: #ffffff;\n}\n\n.footer-button-save:disabled {\n  background-color: #d0d3d9;\n  color: #ffffff;\n}\n\n.underline {\n  text-decoration-line: underline !important;\n  text-decoration-style: solid !important;\n  text-decoration-color: #4563c7 !important ;\n  text-decoration-thickness: 3px !important ;\n  text-underline-offset: 11px !important;\n}\n\n@media (max-width: 768px) {\n  .supporting_data {\n    width: 100%;\n  }\n}\n\n@media (min-width: 992px) {\n  .side-bar {\n    position: fixed;\n  }\n}\n\n@media (min-width: 768px) {\n  .main-screen {\n    margin-left: 0px;\n  }\n}\n\n@media (max-width: 768px) {\n  .image-buttons {\n    height: 30px;\n    width: 30px;\n  }\n}\n\n.logo-image-height {\n  height: 58px;\n  height: 53px;\n}\n\n.font-weight-semi-bold {\n  font-weight: 600;\n}\n\n.line-height-1 {\n  line-height: 1;\n}\n\n.text-size-10 {\n  font-size: 10px;\n}\n\n.text-size-12 {\n  font-size: 12px;\n}\n\n.text-size-13 {\n  font-size: 13px;\n}\n\n.text-size-14 {\n  font-size: 14px;\n}\n\n.text-size-16 {\n  font-size: 16px;\n}\n\n.text-size-18 {\n  font-size: 18px;\n}\n\n.text-size-22 {\n  font-size: 22px;\n}\n\n.text-size-20 {\n  font-size: 20px;\n}\n\n.text-size-24 {\n  font-size: 24px;\n}\n\n.text-size-26 {\n  font-size: 26px;\n}\n\n.text-size-28 {\n  font-size: 28px;\n}\n\n.text-size-32 {\n  font-size: 32px;\n}\n.text-size-36 {\n  font-size: 36px;\n}\n\n.text-size-42 {\n  font-size: 42px;\n}\n\n.text-size-48 {\n  font-size: 48px;\n}\n\n.text-size-52 {\n  font-size: 52px;\n}\n\n.card-shadow {\n  box-shadow: 0 0px 20px 0 rgba(0, 0, 0, 0.05);\n}\n\n@media (min-width: 768px) {\n  .text-size-nitrogen {\n    font-size: 24px;\n  }\n}\n\n@media (max-width: 1480px) {\n  .fieldDetails {\n    flex-wrap: wrap;\n  }\n}\n@media (max-width: 1480px) {\n  .IrrigationMeterDetailsContainer {\n    width: 100% !important;\n    justify-content: center;\n    border-top-right-radius: 14px;\n    border-right: 1px solid #dce0e8 !important;\n    border-bottom: none !important;\n  }\n}\n\n@media (min-width: 1480px) {\n  .FieldDetailsContainer {\n    border-top-right-radius: 14px;\n  }\n}\n\n@media (max-width: 1480px) {\n  .FieldDetailsContainer {\n    border-left: 0.5px solid #dce0e8;\n  }\n}\n\n@media (max-width: 1480px) {\n  .lastUpdatedGaugeText {\n    font-size: 14px !important;\n  }\n}\n\n@media (min-width: 2160px) {\n  .fieldDetailsLargeScreens {\n    line-height: 55px !important;\n  }\n}\n\n/*4 lines height*/\n@media (max-width: 1560px) {\n  .nextActionsContainer {\n    max-height: 256px !important;\n  }\n}\n@media (max-width: 1480px) {\n  .gaugeTitlesContainer {\n    flex-direction: row !important;\n    align-items: center !important;\n  }\n}\n@media (max-width: 768px) {\n  .accumulatedAbsoluteMenu {\n    margin-top: 70px !important;\n  }\n}\n\n@media (min-width: 2660px) {\n  .accumulatedAbsoluteMenu {\n    margin-left: 88px !important;\n    margin-top: 55px !important;\n  }\n}\n\n@media (min-width: 3060px) {\n  .accumulatedAbsoluteMenu {\n    margin-left: 92px !important;\n  }\n}\n\n@media (min-width: 3400px) {\n  .accumulatedAbsoluteMenu {\n    margin-left: 93px !important;\n  }\n}\n\n@media (min-width: 4000px) {\n  .accumulatedAbsoluteMenu {\n    margin-left: 95px !important;\n  }\n}\n\n@media (min-width: 4700px) {\n  .accumulatedAbsoluteMenu {\n    margin-left: 97px !important;\n  }\n}\n\n@media (min-width: 5000px) {\n  .accumulatedAbsoluteMenu {\n    margin-left: 102px !important;\n  }\n}\n@media (min-width: 5500px) {\n  .accumulatedAbsoluteMenu {\n    margin-left: 108px !important;\n  }\n}\n@media (max-width: 1560px) {\n  .nextActionsContainerGraphOnly {\n    max-width: none !important;\n  }\n}\n\n@media (max-width: 1560px) {\n  .dashboardNextActionsContainerGraphOnly {\n    flex-wrap: wrap !important;\n  }\n}\n@media (max-width: 1200px) {\n  .dashboardNextActionsContainer {\n    max-width: none !important;\n  }\n}\n\n@media (max-width: 768px) {\n  .text-size-nitrogen {\n    font-size: 18px;\n  }\n}\n\n@media (min-width: 768px) {\n  .text-size-fertilizer-title {\n    font-size: 18px;\n  }\n}\n@media (max-width: 768px) {\n  .text-size-fertilizer-title {\n    font-size: 14px;\n  }\n}\n\ncanvas#da-gauge {\n  width: 100% !important;\n  height: auto !important;\n}\n\n.dropdown-hover > .dropdown-menu {\n  top: 200%;\n  transition: 0.3s all ease-in-out;\n}\n.dropdown-hover:hover > .dropdown-menu {\n  display: block;\n  top: 100%;\n}\n\n.dropdown-hover > .dropdown-toggle:active {\n  /*Without this, clicking will make it sticky*/\n  pointer-events: none;\n}\n\n@keyframes fadein {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes fadeout {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n@keyframes slide_irrigation {\n  from {\n    width: 0;\n  }\n  to {\n    width: 255px;\n  }\n}\n@keyframes slide_nitrogen {\n  from {\n    width: 0;\n  }\n  to {\n    width: 255px;\n  }\n}\n\n@keyframes slide_close {\n  from {\n    width: 255px;\n  }\n  to {\n    width: 0;\n  }\n}\n\n.custom-checkbox input {\n  height: 16px;\n  width: 16px;\n  position: absolute;\n  top: 2px;\n  left: 1px;\n  opacity: 0;\n}\n.custom-checkbox span {\n  /* <-- Style the artificial checkbox */\n  height: 14px;\n  width: 14px;\n  border: 1px solid #dfe7f0;\n  display: inline-block;\n\n  border-radius: 4px;\n\n  box-shadow:\n    inset 0px 1px 1px white,\n    0px 1px 1px rgba(0, 0, 0, 0.5);\n}\n\n[type='checkbox']:checked + span.check-blue {\n  /* <-- Style its checked state */\n  background: #3f83f7 0% 0% no-repeat padding-box;\n}\n[type='checkbox']:checked + span.check-green {\n  /* <-- Style its checked state */\n  background: #00c1a7 0% 0% no-repeat padding-box;\n}\n\n[type='checkbox']:checked + span.check-orange {\n  /* <-- Style its checked state */\n  background: #ef9331 0% 0% no-repeat padding-box;\n}\n\n[type='checkbox']:checked + span.check-pink {\n  /* <-- Style its checked state */\n  background: #cd91cd 0% 0% no-repeat padding-box;\n}\n\n[type='checkbox']:checked + span.check-blue-third {\n  /* <-- Style its checked state */\n  background: #94c7f6 0% 0% no-repeat padding-box;\n}\n\n[type='checkbox']:checked + span.check-indigo-light {\n  /* <-- Style its checked state */\n  background: #5e70d1 0% 0% no-repeat padding-box;\n}\n\n::placeholder {\n  color: #a8abb7;\n  font-weight: normal;\n}\n\n.modal-dialog {\n  max-width: 860px;\n}\n\n.line-clamp {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.tooltip-inner {\n  background-color: rgba(77, 86, 116, 1);\n  color: rgba(255, 255, 255, 1);\n  padding: 4px 0px;\n  font-family: Source Sans Pro;\n  line-height: 150%;\n  max-width: 280px;\n  padding: 8px 10px;\n  box-shadow: 0px 3px 6px 0px rgba(28, 29, 32, 0.3);\n  text-align: left;\n}\n\n.disable-selector {\n  background: #edeff2 url('../resources/images/icons/header/down_arrow.svg')\n    right 0.75rem center/8px 10px no-repeat !important;\n}\n\n.tooltip.show {\n  opacity: 1 !important;\n}\n\n.tooltip.bs-tooltip-top .arrow:before {\n  border-top-color: rgba(77, 86, 116, 1) !important;\n}\n.tooltip.bs-tooltip-bottom .arrow:before {\n  border-bottom-color: rgba(77, 86, 116, 1) !important;\n}\n.tooltip.bs-tooltip-right .arrow:before {\n  border-right-color: rgba(77, 86, 116, 1) !important;\n}\n.tooltip.bs-tooltip-bottom .tooltip-inner {\n  max-width: 180px;\n}\n\n.color-transition {\n  background-color: #e1e4eb; /* Initial color */\n  transition: background-color 600ms ease-in-out; /* Transition property and duration */\n  animation: colorTransition 600ms infinite alternate;\n}\n\n.white-selector {\n  background: white url('../resources/images/icons/header/down_arrow.svg') right\n    0.75rem center/8px 10px no-repeat !important;\n}\n.disable-selector {\n  background: #edeff2 url('../resources/images/icons/header/down_arrow.svg')\n    right 0.75rem center/8px 10px no-repeat !important;\n}\n\n@keyframes colorTransition {\n  to {\n    background-color: #d0d4db; /* Final color */\n  }\n}\n\n.form-control:focus {\n  border-color: rgba(69, 99, 199, 1);\n  box-shadow: 0 0 0 0;\n}\n\n.form-control:not(:disabled):hover {\n  background-color: rgba(250, 251, 252, 1);\n}\n\n.btn-link:focus {\n  text-decoration: none;\n}\n.btn:focus {\n  outline: 0;\n  box-shadow: 0 0 0 0;\n}\n\n.dropdown-item:hover {\n  background: #eef1f6;\n}\n\n.delete-dropdown-item:hover {\n  background: #fff5f6;\n}\n\n.button-big {\n  background-color: rgba(238, 241, 246, 1) !important;\n}\n\n.button-big:hover {\n  background-color: rgba(220, 224, 232, 1) !important;\n  border: 1px solid rgba(145, 157, 180, 1) !important;\n}\n\n.button-big:active {\n  background-color: rgba(246, 248, 250, 1) !important;\n  border: 1px solid rgba(220, 224, 232, 1) !important;\n}\n\n.button-primary {\n  background-color: rgba(69, 99, 199, 1) !important;\n}\n\n.button-primary:hover {\n  background-color: rgba(37, 69, 176, 1) !important;\n}\n\n.button-primary:active {\n  background-color: rgba(27, 50, 128, 1) !important;\n}\n\n.modal-backdrop {\n  z-index: 999;\n  background: rgba(27, 31, 46, 0.3);\n}\n.modal-tall .modal-content {\n  height: 100%;\n}\n.alert_div:hover {\n  background-color: #f6f8fa;\n}\n.tooltip {\n  z-index: 99999999999999 !important;\n}\n\n.modal-slide .modal-dialog {\n  -webkit-transform: translate(100%, 0);\n  -ms-transform: translate(100%, 0);\n  transform: translate(100%, 0);\n  transition: -webkit-transform 0.5s ease-out;\n  transition: transform 0.5s ease-out;\n  transition:\n    transform 0.5s ease-out,\n    -webkit-transform 0.5s ease-out;\n}\n\n.modal-slide.show .modal-dialog {\n  -webkit-transform: translate(0, 0);\n  -ms-transform: translate(0, 0);\n  transform: translate(0, 0);\n}\n\n.modal-slide.hide .modal-dialog {\n  -webkit-transform: translate(100%, 0);\n  -ms-transform: translate(100%, 0);\n  transform: translate(100%, 0);\n  transition: -webkit-transform 0.5s ease-in-out;\n  transition: transform 0.5s ease-in-out;\n  transition:\n    transform 0.5s ease-in-out,\n    -webkit-transform 0.5s ease-in-out;\n}\n\ninput[type='radio'] {\n  accent-color: #4563c7;\n}\n\ninput[type='checkbox'] {\n  accent-color: #4563c7;\n}\n\n.addBtn {\n  background: white;\n}\n\n.addBtn:hover {\n  background: rgba(238, 241, 246, 0.6);\n}\n\n.addBtn:focus {\n  background: rgba(220, 224, 232, 0.5);\n}\n\n.title {\n  color: #d0d3d9;\n}\n\n.title_active {\n  color: #4d5674;\n}\n\n.title:hover {\n  color: #4563c7;\n}\n\n.danger-button {\n  background-color: var(--color-danger-idel);\n  color: white;\n  border: none;\n}\n\n.danger-button:hover {\n  background-color: var(--color-danger-hover);\n}\n\n.danger-button:focus {\n  background-color: var(--color-danger-idel);\n}\n\n#link_div:hover ~ .underline_div {\n  background-color: #4563c7;\n}\n.underline_div {\n  background-color: #4d5674;\n}\n\n.custom-select {\n  background: url('../resources/images/icons/header/down_arrow.svg') right\n    0.75rem center/8px 10px no-repeat !important;\n}\n\n.DayPickerInput-OverlayWrapperRight {\n  right: 12px;\n  position: absolute;\n  background-color: white;\n  margin-top: 2px;\n  z-index: 1;\n}\n.archive-color {\n  color: #919db4 !important;\n}\n\n.chip {\n  height: 32px;\n  border-radius: 30px;\n  padding: 8px 16px 8px 16px;\n  line-height: 16px;\n  color: var(--color-grey-45);\n  font-size: 14px;\n  font-weight: 600;\n  text-align: center;\n  margin-right: 8px;\n  cursor: pointer;\n  margin-bottom: 8px;\n}\n\n.chip--selected {\n  background-color: var(--color-grey-45);\n  color: white;\n}\n\n.chip--selected:hover {\n  background-color: var(--color-grey-34);\n  color: var(--color-grey-100);\n}\n\n.chip--selected:active {\n  background-color: var(--color-grey-25);\n  color: var(--color-grey-100);\n}\n\n.chip--notselected {\n  background-color: var(--color-grey-96);\n  color: var(--color-grey-45);\n}\n\n.chip--notselected:hover {\n  background-color: var(--color-grey-91);\n  color: var(--color-grey-45);\n}\n\n.chip--notselected:active {\n  background-color: var(--color-grey-96);\n  color: var(--color-grey-25);\n}\n\n.chip--disabled {\n  background-color: var(--color-disabled-95);\n  color: var(--color-disabled-64);\n  cursor: auto;\n}\n\n.modal-input-container {\n  width: 142px;\n}\n\n.deleteItem:hover {\n  background: #fff5f6 !important;\n}\n\n.disabled-button {\n  background-color: var(--color-disabled-85);\n  align-items: center;\n  display: flex;\n}\n\n.primary-button {\n  background-color: var(--color-primary-idel);\n  align-items: center;\n  display: flex;\n  border: transparent;\n}\n\n.primary-button:hover {\n  background-color: var(--color-primary-hover);\n}\n\n.primary-button:active {\n  background-color: var(--color-primary-on-press);\n}\n.primary-button:disabled {\n  background-color: var(--color-disabled-85);\n  pointer-events: none;\n}\n.secondary-button {\n  background-color: var(--color-grey-96);\n  border: 1px solid var(--color-grey-91);\n  align-items: center;\n  display: flex;\n}\n\n.secondary-button:hover {\n  background-color: var(--color-grey-91);\n  border: 1px solid var(--color-grey-98);\n}\n\n.secondary-button:active {\n  background-color: var(--color-grey-98);\n  border: 1px solid var(--color-grey-91);\n}\n\n.ghost-button {\n  background-color: white;\n  border: 1px solid var(--color-grey-71);\n  color: var(--color-grey-45);\n}\n\n.ghost-button:hover {\n  background-color: var(--color-grey-98);\n  border: 1px solid var(--color-grey-71);\n}\n\n.ghost-button:active {\n  background-color: var(--color-grey-91);\n  border: 1px solid var(--color-grey-71);\n}\n\n.css-6hp17o-MuiList-root-MuiMenu-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  position: relative;\n  outline: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
